import { css } from 'styled-components';
import token from 'styled-token';
import { StyledHelpCircle, StyledHelpQuestion } from '../../components/Icon/icons/IconHelp';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';

/** @class TriggerButtonMixin */
/** @method */
export var TriggerButtonMixin = token({
  borderRadius: 'TriggerButton.borderRadius',
  boxShadow: 'TriggerButton.boxShadow',
  size: 'TriggerButton.size',
  helpCircleFill: 'TriggerButton.helpCircleFillColor',
  helpCircleFillActive: 'TriggerButton.helpCircleFillColorActive',
  helpCircleFillHover: 'TriggerButton.helpCircleFillColorHover',
  helpCircleStroke: 'TriggerButton.helpCircleStrokeColor',
  helpCircleStrokeHover: 'TriggerButton.helpCircleStrokeColorHover',
  helpCircleStrokeActive: 'TriggerButton.helpCircleStrokeColorActive',
  helpQuestionFill: 'TriggerButton.helpQuestionFillColor',
  helpQuestionFillActive: 'TriggerButton.helpQuestionFillColorActive'
}, function (_ref) {
  var borderRadius = _ref.borderRadius,
    boxShadow = _ref.boxShadow,
    size = _ref.size,
    helpCircleFill = _ref.helpCircleFill,
    helpCircleFillActive = _ref.helpCircleFillActive,
    helpCircleFillHover = _ref.helpCircleFillHover,
    helpCircleStroke = _ref.helpCircleStroke,
    helpCircleStrokeHover = _ref.helpCircleStrokeHover,
    helpCircleStrokeActive = _ref.helpCircleStrokeActive,
    helpQuestionFill = _ref.helpQuestionFill,
    helpQuestionFillActive = _ref.helpQuestionFillActive;
  return css(["background:transparent;display:inline-block;vertical-align:top;border:0;padding:0;border-radius:", ";height:", "px;width:", "px;", "{fill:", ";stroke:", ";}", "{fill:", ";}", ";&:active{", "{stroke:", ";fill:", ";}", "{fill:", ";}}&:focus{outline:none;box-shadow:", ";}position:relative;&:after{content:'';cursor:pointer;position:absolute;top:-5px;right:-5px;bottom:-5px;left:-5px;}"], borderRadius, size, size, StyledHelpCircle, helpCircleFill, helpCircleStroke, StyledHelpQuestion, helpQuestionFill, hoverMediaQueryMixin("\n            " + StyledHelpCircle + " {\n                stroke: " + helpCircleStrokeHover + ";\n                fill: " + helpCircleFillHover + ";\n            }\n        "), StyledHelpCircle, helpCircleStrokeActive, helpCircleFillActive, StyledHelpQuestion, helpQuestionFillActive, boxShadow);
});